import {ComponentPropsWithRef, forwardRef, ChangeEvent, ReactNode} from 'react';
import {
  Input,
  Label,
  Wrapper,
  SecondaryWrapper,
  SecondaryInput,
} from '../shared';
import {NumericFormat} from 'react-number-format';
import {InputState} from '../../../interface';
import styled from 'styled-components';
import {HashIcon} from '../../icons';
import {getColorFromTheme} from '../../../ui-utils';

export interface TNumberInputProps extends ComponentPropsWithRef<'input'> {
  state?: InputState;
  label: string;
  icon?: ReactNode;
  disabled?: boolean;
  compact?: boolean;
}
type inputType = string | number | undefined;
const Icon = styled.span<{$compact?: boolean}>`
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${getColorFromTheme('textBody')};
  svg {
    width: ${({$compact}) => ($compact ? '16px' : '20px')};
    height: ${({$compact}) => ($compact ? '16px' : '20px')};
    stroke: ${getColorFromTheme('textBody')};
  }
`;
const LabelX = styled(Label)<{$compact?: boolean}>`
  min-width: ${({$compact}) => ($compact ? '44px' : 'auto')};
  padding: ${({$compact}) => ($compact ? '10px' : '12px')};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NumberWrapper = styled(Wrapper)<{$compact?: boolean}>`
  height: ${({$compact}) => ($compact ? '44px' : '52px')};
`;

const CompactInput = styled(Input)`
  height: 44px;
  padding: 5px 12px;
  font-size: 14px;
  line-height: 22px;
`;

export const NumberInput = forwardRef(
  ({
    id,
    disabled,
    state,
    value,
    defaultValue,
    icon,
    compact,
    onChange,
    ...props
  }: TNumberInputProps) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      const number = event.target.value.replaceAll(',', '');
      event.target.value = number;

      onChange && onChange(event);
    };
    return (
      <NumberWrapper
        htmlFor={id}
        disabled={disabled}
        state={state}
        $compact={compact}>
        <LabelX disabled={disabled} $compact={compact}>
          <Icon $compact={compact}>{icon || <HashIcon />}</Icon>
        </LabelX>
        <NumericFormat
          value={value as inputType}
          defaultValue={defaultValue as inputType}
          onChange={handleChange}
          {...props}
          disabled={disabled}
          customInput={compact ? CompactInput : Input}
          type={'text'}
          thousandSeparator=","
        />
      </NumberWrapper>
    );
  },
);
export const SecondaryNumberInput = forwardRef(
  ({
    id,
    disabled,
    state,
    value,
    defaultValue,
    onChange,
    ...props
  }: TNumberInputProps) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      const number = event.target.value.replaceAll(',', '');
      event.target.value = number;

      onChange && onChange(event);
    };

    return (
      <SecondaryWrapper htmlFor={id} disabled={disabled} state={state}>
        <NumericFormat
          value={value as inputType}
          defaultValue={defaultValue as inputType}
          onChange={handleChange}
          {...props}
          disabled={disabled}
          customInput={SecondaryInput}
          type={'text'}
          thousandSeparator=","
        />

        <LabelX disabled={disabled} borderRadius="0px 7px 7px 0px">
          <Icon>
            <HashIcon />
          </Icon>
        </LabelX>
      </SecondaryWrapper>
    );
  },
);
NumberInput.displayName = 'NumberInput';
